export const ENV = (process.env.REACT_APP_ENV || 'production').trim();

export const API_ENDPOINT = (process.env.REACT_APP_API_ENDPOINT || '').trim();
export const CDN_ENDPOINT = (process.env.REACT_APP_CDN_ENDPOINT || '').trim();
export const GOOGLE_MAPS_PLACE_APIKEY = (process.env.REACT_APP_GOOGLE_MAPS_PLACE_APIKEY || '').trim();
export const COOKIE_DOMAIN = (process.env.REACT_APP_COOKIE_DOMAIN || '').trim();

if (!API_ENDPOINT) throw new Error('Please provide an API_ENDPOINT');

export const SENTRY_KEY = (process.env.REACT_APP_SENTRY_KEY || '').trim();

export const TOAST_DEFAULT_TIMEOUT = 3000;
export const TOAST_ERROR_TIMEOUT = 5000;

export const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'homolog';

export const APP_BLINKET_URL = (process.env.REACT_APP_BLINKET_URL || '').trim();
export const BLINKET_TICKETS_URL = (process.env.REACT_APP_BLINKET_APP_URL || '').trim();
export const REACT_TOKEN = (process.env.REACT_APP_TOKEN || '').trim();
export const REACT_SECRET = (process.env.REACT_APP_SECRET || '').trim();

export const ACCOUNTS_PARTNER = 'b1b17e0c-3438-4316-bb6d-283c9ff622c1';
export const ACCOUNTS_ENV =
  process.env.REACT_APP_ENV === 'production' ? {} : { env: ENV === 'development' ? 'dev' : 'qa' };

export const GOOGLE_ANALYTICS_ID = (process.env.REACT_APP_GOOGLE_ANALYTICS_ID || '').trim();
